// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faCheck, faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import DreamSelectModal from 'components/UI/DreamSelectModal/DreamSelectModal';
import SkillModal from 'components/UI/SkillModal/SkillModal';
import Slider from 'components/UI/Slider/Slider';
import Spark from 'components/UI/Spark/Spark';
import Toggle from 'components/UI/Toggle/Toggle';
import { AnimatePresence, motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import EmojiSelector from 'pages/Growth/Reflect/components/ReflectionItem/components/EmojiSelector/EmojiSelector';
import React, { useContext, useEffect, useState } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { ReflectionItemContext } from '../../ReflectionItem';
import ReflectionOverviewArea from '../ReflectionOverviewArea/ReflectionOverviewArea';
import './ActivityReflection.module.scss';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import { ReflectContext } from 'pages/Growth/Reflect/Reflect';
// =========================

export default function ActivityReflection() {
  const { reflection, activity, save, setSaveState, saveState } = useContext(
    ReflectionItemContext
  );
  const { loading } = useContext(ReflectContext);

  const peerReflections = useRedux((state) => {
    const reflections = state.reflection?.entities.allIds.map(
      (id) => state.reflection?.entities.byId[id]
    );

    return reflections?.filter(
      (r) =>
        r?.project_process_id === activity?.id &&
        r?.for_user?.id === state.authentication?.user?.id
    );
  });

  const [isToggled, setIsToggled] = useState(
    reflection?.contributed === undefined ? true : !!reflection.contributed
  );
  const [finished, setFinished] = useState(reflection?.finished || false);
  const [value, setValue] = useState(reflection?.result || 0);

  const [skillModalIsOpen, setSkillModalIsOpen] = useState(false);

  const translate = useTranslate();

  useEffect(() => {
    if (value) setSaveState((prev) => ({ ...prev, result: value }));
  }, [value]);

  const [counter1, setCounter1] = useState(0);
  useEffect(() => {
    if (counter1 === 0) return setCounter1(1);

    save({ ...saveState, contributed: isToggled });
    setSaveState((prev) => ({ ...prev, contributed: isToggled }));
  }, [isToggled]);

  const [counter2, setCounter2] = useState(0);
  useEffect(() => {
    if (counter2 === 0) return setCounter2(1);

    save({ ...saveState, finished });
    setSaveState((prev) => ({ ...prev, finished }));
  }, [finished]);

  const saveStateSparks = useRedux((state) =>
    saveState.sparks.map((spark) => state.spark?.entities.byId[spark])
  );

  const [sparksState, setSparksState] = useState(
    saveStateSparks || reflection?.sparks || []
  );

  useEffect(() => {
    if (reflection?.sparks?.length) {
      setSparksState(reflection?.sparks);
    }
  }, [reflection?.sparks]);

  return (
    <>
      <motion.div styleName="container" {...framerFade}>
        <div styleName={`wrapper ${loading ? 'loading' : ''}`}>
          <div>
            <strong>{translate('general.terms.executed')}</strong>
            {loading && (
              <FontAwesomeIcon
                styleName="loading-icon"
                icon={faSpinnerThird}
                spin
              />
            )}
            <span>{translate('reflection.show-muscles')}</span>
            <Toggle isToggled={isToggled} setIsToggled={setIsToggled} />
          </div>
          <div styleName={`grid ${isToggled ? '' : 'inactive'}`}>
            <div>
              <strong>{translate('reflection.terms.experience')}</strong>
              <span>{translate('reflection.experience-activity')}</span>
              <EmojiSelector />
            </div>
            <div>
              <strong>{translate('general.terms.result')}</strong>
              <span>{translate('reflection.reflect-on-activity')}</span>
              <Slider value={value} setValue={setValue} />
            </div>
            <div>
              <strong>{translate('general.terms.skills')}</strong>
              <span>{translate('reflection.show-activities')}</span>
              <Button
                color={sparksState.length ? 'purple' : 'double-grey'}
                onClick={() => setSkillModalIsOpen(true)}
              >
                {sparksState.length ? `${sparksState.length} ` : ''}
                Spark
                {sparksState.length > 1 || sparksState.length === 0
                  ? 's'
                  : ''}{' '}
                <FontAwesomeIcon icon={faPlus} />
              </Button>
              {!!sparksState.length && (
                <div styleName="sparks-wrapper">
                  <AnimatePresence>
                    {sparksState.map(
                      (spark) =>
                        !!spark && <Spark spark={spark} key={spark?.id} />
                    )}
                  </AnimatePresence>
                </div>
              )}
            </div>
            <div styleName="button-wrapper">
              <DreamSelectModal
                selected={saveState.dreams}
                handleSubmit={(dreams) => {
                  setSaveState((prev) => ({
                    ...prev,
                    dreams,
                  }));
                  save({
                    ...saveState,
                    dreams,
                  });
                }}
              />
              <CircleButton
                icon={faCheck}
                color={finished ? 'green' : 'dark-grey'}
                onClick={() => setFinished((prev) => !prev)}
              />
            </div>
          </div>
        </div>
        <ReflectionOverviewArea
          inactive={!isToggled}
          reflections={peerReflections || []}
        />
      </motion.div>
      <AnimatePresence>
        {!!skillModalIsOpen && (
          <SkillModal setSkillModalIsOpen={setSkillModalIsOpen} />
        )}
      </AnimatePresence>
    </>
  );
}
